/* Все отзывы магазина — модалка со скроллом и подгрузкой. */
import { useEffect, useState } from 'react';
import Modal from './Modal.jsx';
import { ReviewCard, Stars } from './Product.jsx';
import Button from './Button.jsx';
import api from '../lib/api.js';
import { ratingsLabel } from '../lib/format.js';

export default function AllReviewsModal({ onClose }) {
  const [state, setState] = useState({ items: [], summary: null, loading: true, offset: 0, hasMore: false });

  const load = (offset = 0) => {
    api
      .reviews({ offset, limit: 12 })
      .then((res) =>
        setState((prev) => ({
          items: offset ? [...prev.items, ...res.items] : res.items,
          summary: res.summary,
          loading: false,
          offset: res.nextOffset,
          hasMore: res.hasMore,
        })),
      )
      .catch(() => setState((prev) => ({ ...prev, loading: false })));
  };

  useEffect(() => {
    load(0);
  }, []);

  return (
    <Modal title="Отзывы покупателей" sub="Все отзывы магазина, свежие сверху" wide onClose={onClose}>
      {state.summary ? (
        <div className="rating-line" style={{ marginBottom: 18 }}>
          <Stars rating={state.summary.rating} />
          <b>{state.summary.rating}</b>
          <span className="u-dim">· {ratingsLabel(state.summary.count)}</span>
        </div>
      ) : null}

      <div className="all-reviews">
        {state.loading && !state.items.length
          ? Array.from({ length: 3 }, (_, i) => <div key={i} className="skeleton" style={{ height: 120 }} />)
          : state.items.map((r, i) => (
              <div key={r.id} style={{ animation: `riseSm .5s cubic-bezier(.16,1,.3,1) ${Math.min(i, 8) * 50}ms both` }}>
                <ReviewCard review={r} showProduct />
              </div>
            ))}
      </div>

      {state.hasMore ? (
        <div className="reviews-more">
          <Button variant="ghost" onClick={() => load(state.offset)}>Показать ещё</Button>
        </div>
      ) : null}
    </Modal>
  );
}
